import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/the-912-am-email-failure-that-costs-small-businesses-hours")({
  beforeLoad: () => {
    throw redirect({ to: "/articles", statusCode: 301 });
  },
});
